const loadmoreOnClick = (target) => {
  if (target) {
    target.addEventListener('click', (ev) => {
      let hiddenEls = [...document.querySelectorAll(target.dataset.target)]
      let dataIndex = parseInt(target.dataset.index)

      if (hiddenEls.length <= dataIndex) {
        target.style.display = 'none'
      } else {
        Array.from(hiddenEls.slice(dataIndex, dataIndex + 12), el => el.classList.remove('is-hidden'))
        target.dataset.index = dataIndex + 12
      }
    })
  } else {
    console.warn('Load More On Click: No target given')
  }
}

const initLoadmore = () => {
  const loadmoreEls = document.querySelectorAll('.js-load-more')
  if (loadmoreEls) {
    Array.from(loadmoreEls, target => loadmoreOnClick(target))
  }
}

export { initLoadmore }